export const industriesList =[
    {
        "value": "blockchain"
    },
    {
        "value": "crm"
    },
    {
        "value": "ERP"
    },
    {
        "value": "Retail"
    },
    {
        "value": "Logistics"
    },
    {
        "value": "Marketing"
    },
    {
        "value": "Publication"
    },
    {
        "value": "DevOps"
    },
    {
        "value": "Agriculture"
    },
    {
        "value": "Ecommerce"
    },
    {
        "value": "insurance"
    },
    {
        "value": "Social Media"
    },
    {
        "value": "Job Classified"
    },
    {
        "value": "Business Development"
    },
    {
        "value": "DropShipping Automation"
    },
    {
        "value": "Amazon FBA"
    },
    {
        "value": "Salesforce"
    },
    {
        "value": "Amazon"
    },
    {
        "value": "Digital Marketing"
    },
    {
        "value": "weather forecast"
    },
    {
        "value": "Consulting"
    },
    {
        "value": "Real Estate"
    },
    {
        "value": "Cosmetics"
    },
    {
        "value": "Automotive"
    },
    {
        "value": "Gaming"
    },
    {
        "value": "Entertainment"
    },
    {
        "value": "Media Agencies"
    },
    {
        "value": "Textile"
    },
    {
        "value": "Medical"
    },
    {
        "value": "Government"
    },
    {
        "value": "Education"
    },
    {
        "value": "Hospitality"
    },
    {
        "value": "Job Portal"
    },
    {
        "value": "Banking"
    },
    {
        "value": "Fantasy Game"
    },
    {
        "value": "Automobile"
    },
    {
        "value": "Energy"
    },
    {
        "value": "RealState"
    },
    {
        "value": "Cryptographic signature"
    },
    {
        "value": "Exchange Plateform"
    },
    {
        "value": "Loyalty"
    },
    {
        "value": "Careers"
    },
    {
        "value": "Finance"
    },
    {
        "value": "Freight Management Plateform"
    },
    {
        "value": "Supply Chain"
    },
    {
        "value": "Trade"
    },
    {
        "value": "HealthCare"
    },
    {
        "value": "ART"
    },
    {
        "value": "Food"
    },
    {
        "value": "Fleet Management System"
    },
    {
        "value": "Document Management System"
    },
    {
        "value": "fitness"
    },
    {
        "value": "Sales & Support"
    },
    {
        "value": "Ride Sharing"
    },
    {
        "value": "Portfolio Investments"
    },
    {
        "value": "Coupon"
    },
    {
        "value": "Accounting"
    },
    {
        "value": "Lease"
    },
    {
        "value": "Payment Gateway"
    },
    {
        "value": "Webinar"
    },
    {
        "value": "Games"
    },
    {
        "value": "Help Desk"
    },
    {
        "value": "Lead Mansgement System"
    },
    {
        "value": "Credit Scoring"
    },
    {
        "value": "Chatbots"
    },
    {
        "value": "VPN"
    },
    {
        "value": "Hardware"
    },
    {
        "value": "Music"
    },
    {
        "value": "Video Chat"
    },
    {
        "value": "Casino"
    },
    {
        "value": "Game Development"
    },
    {
        "value": "Game Play"
    },
    {
        "value": "Social Networking"
    },
    {
        "value": "Audit"
    },
    {
        "value": "Rastaurant"
    },
    {
        "value": "Delivery Services"
    },
    {
        "value": "Cyber Security"
    },
    {
        "value": "Internet of Things (IOT)"
    },
    {
        "value": "Artificial Inteligence (AI)"
    },
    {
        "value": "Robotics"
    },
    {
        "value": "Telemedicine"
    },
    {
        "value": "Learning Management System (LMS)"
    },
    {
        "value": "Elearning"
    },
    {
        "value": "Telecommunication"
    },
    {
        "value": "Human Resource"
    },
    {
        "value": "Crowd Funding"
    },
    {
        "value": "Security"
    },
    {
        "value": "Market Intelligence"
    },
    {
        "value": "Transportation"
    },
    {
        "value": "Assets Management"
    },
    {
        "value": "Pets"
    },
    {
        "value": "Travel"
    },
    {
        "value": "Scheduling Application"
    },
    {
        "value": "Interpreting Plateforms"
    },
    {
        "value": "Event Management"
    },
    {
        "value": "Cloud Plateforms"
    },
    {
        "value": "Parking"
    },
    {
        "value": "MarketPlace"
    },
    {
        "value": "Law Firm"
    },
    {
        "value": "VM"
    }
]